// import React from 'react';
// import { Box, Typography } from '@mui/material';

// const Footer = () => {
//   return (
//     <Box
//       component="footer"
//       sx={{
//         p: 1.5,
//         textAlign: "center",
//         borderTop: "1px solid",
//         borderColor: "divider",
//         mt: "auto",
//       }}
//     >
//       <Typography variant="caption" color="text.secondary">
//         © 2024 Patheya Foundation.
//       </Typography>
//     </Box>
//   );
// };
// export default Footer;

import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        p: 1.5,
        textAlign: "center",
        borderTop: "1px solid",
        borderColor: "divider",
        mt: "auto",
      }}
    >
      <Typography variant="caption" color="text.secondary">
        © {new Date().getFullYear()} Patheya Foundation.
      </Typography>
    </Box>
  );
};

export default Footer;